import { render } from "./TopServicesList.vue?vue&type=template&id=41dc1c88&scoped=true"
import script from "./TopServicesList.vue?vue&type=script&lang=js"
export * from "./TopServicesList.vue?vue&type=script&lang=js"

import "./TopServicesList.vue?vue&type=style&index=0&id=41dc1c88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41dc1c88"]])

export default __exports__